import { EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

const _c0 = ["input"];
const _c1 = function (a0, a1) { return { "disabled-checkbox": a0, error: a1 }; };
function CheckboxComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(1, _c1, ctx_r0.formControl.disabled, ctx_r0.isError && !ctx_r0.formControl.disabled));
} }
function CheckboxComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(1, _c1, ctx_r1.formControl.disabled, ctx_r1.isError && !ctx_r1.formControl.disabled));
} }
const _c2 = function (a0) { return { cursor: a0 }; };
class CheckboxComponent {
    constructor() {
        this.isError = false;
        this.isIndeterminate = false;
        this.name = "";
        this.formControl = new FormControl();
        this.valueChange = new EventEmitter();
    }
    set type(value) {
        this.isError = value === "Error";
    }
    set indeterminate(value) {
        if (value) {
            this.formControl.setValue(true);
            this.valueChange.emit({
                name: this.name,
                value: true
            });
        }
        else {
            this.formControl.setValue(false);
            this.valueChange.emit({
                name: this.name,
                value: false
            });
        }
        this.isIndeterminate = value;
    }
    set checked(value) {
        if (value)
            this.formControl.setValue(true);
        else
            this.formControl.setValue(false);
    }
    set disabled(value) {
        if (value)
            this.formControl.disable();
        else
            this.formControl.enable();
    }
    ngOnInit() { }
    toggleState() {
        if (this.isIndeterminate) {
            this.isIndeterminate = false;
            this.formControl.setValue(true);
        }
        else {
            if (this.formControl.value)
                this.formControl.setValue(false);
            else
                this.formControl.setValue(true);
        }
        this.valueChange.emit({
            name: this.name,
            value: this.formControl.value
        });
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); };
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["mis-checkbox"]], viewQuery: function CheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputBox = _t.first);
    } }, inputs: { name: "name", formControl: "formControl", type: "type", indeterminate: "indeterminate", checked: "checked", disabled: "disabled" }, outputs: { valueChange: "valueChange" }, decls: 4, vars: 6, consts: [[1, "checkbox-container", 3, "ngStyle", "click"], ["hidden", "", "type", "checkbox", 3, "formControl", "click"], ["class", "checkmark", "tabindex", "0", 3, "ngClass", 4, "ngIf"], ["class", "checkmark indeterminate", "tabindex", "0", 3, "ngClass", 4, "ngIf"], ["tabindex", "0", 1, "checkmark", 3, "ngClass"], ["tabindex", "0", 1, "checkmark", "indeterminate", 3, "ngClass"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function CheckboxComponent_Template_div_click_0_listener() { return !ctx.formControl.disabled && ctx.toggleState(); });
        ɵngcc0.ɵɵelementStart(1, "input", 1);
        ɵngcc0.ɵɵlistener("click", function CheckboxComponent_Template_input_click_1_listener($event) { return $event.stopPropagation(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, CheckboxComponent_span_2_Template, 1, 4, "span", 2);
        ɵngcc0.ɵɵtemplate(3, CheckboxComponent_span_3_Template, 1, 4, "span", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(4, _c2, ctx.formControl.disabled ? "not-allowed" : "pointer"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.formControl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isIndeterminate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isIndeterminate);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgStyle, ɵngcc2.CheckboxControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective], styles: [".checkbox-container[_ngcontent-%COMP%]{height:20px;width:20px;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:sub}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;cursor:pointer}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .checkmark[_ngcontent-%COMP%]{position:absolute;height:20px;width:20px}.checkmark[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;top:0;left:0;border-radius:4px;background-color:#fff;border:2px solid #6a737d;box-sizing:border-box}.checkmark[_ngcontent-%COMP%]:hover{border-color:#929dab}.checkmark[_ngcontent-%COMP%]:focus, .checkmark[_ngcontent-%COMP%]:focus-within{box-shadow:0 0 0 .09em #fff,0 0 .01em .2em #0937b2;outline:none}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]{background-color:#0937b2;border-color:#0937b2}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkmark.disabled-checkbox[_ngcontent-%COMP%]{background-color:#c8cdd3;border-color:#c8cdd3}.checkmark[_ngcontent-%COMP%]:after{content:\"\";position:absolute;display:none}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]:after{display:block}.checkbox-container[_ngcontent-%COMP%]   .checkmark[_ngcontent-%COMP%]:after{top:1px;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}.checkbox-container[_ngcontent-%COMP%]   .checkmark.indeterminate[_ngcontent-%COMP%]:after{top:2px;width:2px;height:0;border:solid #fff;border-width:0 0 12px;border-radius:14px;transform:rotate(90deg);-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg)}.disabled-checkbox[_ngcontent-%COMP%]{pointer-events:none;border-color:#c8cdd3}.error[_ngcontent-%COMP%]{border-color:#b00020}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .error.checkmark[_ngcontent-%COMP%]{border:#b00020!important;background:#b00020!important}.checkbox-container[_ngcontent-%COMP%]   .error.checkmark[_ngcontent-%COMP%]:after{top:3px;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}.checkbox-container[_ngcontent-%COMP%]   .error.checkmark.indeterminate[_ngcontent-%COMP%]:after{top:4px;width:2px;height:0;border:solid #fff;border-width:0 0 12px;border-radius:14px;transform:rotate(90deg);-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg)}.error[_ngcontent-%COMP%]:focus, .error[_ngcontent-%COMP%]:focus-within{box-shadow:none!important;outline:none}"] });
CheckboxComponent.ctorParameters = () => [];
CheckboxComponent.propDecorators = {
    inputBox: [{ type: ViewChild, args: ["input",] }],
    type: [{ type: Input }],
    indeterminate: [{ type: Input }],
    checked: [{ type: Input }],
    disabled: [{ type: Input }],
    name: [{ type: Input }],
    formControl: [{ type: Input }],
    valueChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{ selector: "mis-checkbox", template: "<div\n  class=\"checkbox-container\"\n  [ngStyle]=\"{ cursor: formControl.disabled ? 'not-allowed' : 'pointer' }\"\n  (click)=\"!formControl.disabled && toggleState()\"\n>\n  <input hidden type=\"checkbox\" [formControl]=\"formControl\" (click)=\"$event.stopPropagation()\" />\n  <span\n    class=\"checkmark\"\n    tabindex=\"0\"\n    *ngIf=\"!isIndeterminate\"\n    [ngClass]=\"{\n      'disabled-checkbox': formControl.disabled,\n      error: isError && !formControl.disabled\n    }\"\n  ></span>\n  <span\n    class=\"checkmark indeterminate\"\n    tabindex=\"0\"\n    *ngIf=\"isIndeterminate\"\n    [ngClass]=\"{\n      'disabled-checkbox': formControl.disabled,\n      error: isError && !formControl.disabled\n    }\"\n  ></span>\n</div>\n", styles: [".checkbox-container{height:20px;width:20px;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:sub}.checkbox-container input{opacity:0;cursor:pointer}.checkbox-container input,.checkmark{position:absolute;height:20px;width:20px}.checkmark{display:flex;justify-content:center;align-items:center;top:0;left:0;border-radius:4px;background-color:#fff;border:2px solid #6a737d;box-sizing:border-box}.checkmark:hover{border-color:#929dab}.checkmark:focus,.checkmark:focus-within{box-shadow:0 0 0 .09em #fff,0 0 .01em .2em #0937b2;outline:none}.checkbox-container input:checked~.checkmark{background-color:#0937b2;border-color:#0937b2}.checkbox-container input:checked~.checkmark.disabled-checkbox{background-color:#c8cdd3;border-color:#c8cdd3}.checkmark:after{content:\"\";position:absolute;display:none}.checkbox-container input:checked~.checkmark:after{display:block}.checkbox-container .checkmark:after{top:1px;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}.checkbox-container .checkmark.indeterminate:after{top:2px;width:2px;height:0;border:solid #fff;border-width:0 0 12px;border-radius:14px;transform:rotate(90deg);-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg)}.disabled-checkbox{pointer-events:none;border-color:#c8cdd3}.error{border-color:#b00020}.checkbox-container input:checked~.error.checkmark{border:#b00020!important;background:#b00020!important}.checkbox-container .error.checkmark:after{top:3px;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}.checkbox-container .error.checkmark.indeterminate:after{top:4px;width:2px;height:0;border:solid #fff;border-width:0 0 12px;border-radius:14px;transform:rotate(90deg);-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg)}.error:focus,.error:focus-within{box-shadow:none!important;outline:none}"] }]
    }], function () { return []; }, { name: [{
            type: Input
        }], formControl: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], type: [{
            type: Input
        }], indeterminate: [{
            type: Input
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], inputBox: [{
            type: ViewChild,
            args: ["input"]
        }] }); })();

class CheckboxModule {
    static forRoot() {
        return { ngModule: CheckboxModule, providers: [] };
    }
}
CheckboxModule.ɵfac = function CheckboxModule_Factory(t) { return new (t || CheckboxModule)(); };
CheckboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CheckboxModule });
CheckboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, ReactiveFormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [CheckboxComponent],
                imports: [CommonModule, ReactiveFormsModule],
                exports: [CheckboxComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CheckboxModule, { declarations: function () { return [CheckboxComponent]; }, imports: function () { return [CommonModule, ReactiveFormsModule]; }, exports: function () { return [CheckboxComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CheckboxComponent, CheckboxModule };

